var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper mx-auto text-center container" },
    [
      _c(
        "v-btn",
        {
          staticClass: "pharmacists-requests",
          attrs: { "min-width": "30", fab: "", small: "" },
          on: {
            click: function ($event) {
              _vm.isDialogOpen = true
            },
          },
        },
        [
          _c("v-icon", [_vm._v("mdi-account-multiple")]),
          _vm._v(" "),
          _vm.numOfRequests
            ? _c("span", { staticClass: "pharmacists-requests-count" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.numOfRequests) + "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.numOfActiveRequests
            ? _c("span", { staticClass: "active-pharmacists-requests-count" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.numOfActiveRequests) +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            scrollable: "",
            "content-class": "v-application",
            "max-width": "90vw",
          },
          model: {
            value: _vm.isDialogOpen,
            callback: function ($$v) {
              _vm.isDialogOpen = $$v
            },
            expression: "isDialogOpen",
          },
        },
        [
          _c(
            "v-card",
            {
              attrs: {
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
                elevation: "2",
              },
            },
            [
              _c("v-card-title", [_vm._v("Anfragen durch Freiberufler")]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "h5", attrs: { cols: "12" } },
                        [
                          _vm._v(
                            "Freiberufler Können Anfragen senden, die hier gelistet\n                        werden"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("div", [
                            _c("b", [_vm._v("Apotheke:")]),
                            _vm._v(" "),
                            _vm.pharmacyHref
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.pharmacyHref,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.pharmacyLabel) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v(_vm._s(_vm.pharmacyLabel))]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v("Termin:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-3 pr-4 dates",
                                  attrs: { cols: "auto" },
                                },
                                _vm._l(_vm.group, function (appointment) {
                                  return _c("div", [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          appointment.commited && "committed",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.formatDate(appointment.date)
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-2" }, [
                                      _vm._v(
                                        " " + _vm._s(appointment.display_time)
                                      ),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v("HBA zwingend notwendig: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { staticClass: "ml-3 hba-required" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.appointment.hba ? "ja" : "nein")
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v("WWS: ")]
                              ),
                              _vm._v(" "),
                              _c("v-col", { staticClass: "ml-2" }, [
                                _vm._v(_vm._s(_vm.pharmacy.erp)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v("Direkt Zusage: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { staticClass: "ml-2 direct-approval" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.pharmacy.no_approval_required
                                        ? "ja"
                                        : "nein"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.assignedPharmacist?._id
                            ? _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "font-weight-bold",
                                      attrs: { cols: "auto" },
                                    },
                                    [_vm._v("Freiberufler: ")]
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { staticClass: "ml-2" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: `/pharmacists/${_vm.assignedPharmacist._id}`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.assignedPharmacist.firstname
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.assignedPharmacist.lastname
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.numOfRequests && _vm.group.length
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-simple-table", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c("th", [_vm._v("Name")]),
                                              _vm._v(" "),
                                              _c("th", [
                                                _vm._v("Datum der Anfrage"),
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [
                                                _vm._v(
                                                  "Entfernung/ Fahrkosten"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("WWS | HBA")]),
                                              _vm._v(" "),
                                              _c("th", [
                                                _vm._v("war schonmal da?"),
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [
                                                _vm._v(
                                                  "Anmerkungen /Kommentar"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [
                                                _vm._v("Auswählen/Absage"),
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Status")]),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          !_vm.hydrateOnDialogOpen ||
                                          _vm.hasOpenedDialog
                                            ? _c(
                                                "tbody",
                                                _vm._l(
                                                  (
                                                    _vm.group[0] ||
                                                    _vm.appointment
                                                  ).pharmacist_requests,
                                                  function (
                                                    request,
                                                    pharmacistId,
                                                    idx
                                                  ) {
                                                    return _c(
                                                      "PharmacistRequestTableRow",
                                                      {
                                                        key: `${pharmacistId}-${
                                                          request[2]
                                                        }-${
                                                          (
                                                            _vm.group[0] ||
                                                            _vm.appointment
                                                          ).wf_state
                                                        }`,
                                                        attrs: {
                                                          request: request,
                                                          pharmacistId:
                                                            pharmacistId,
                                                          idx: idx,
                                                          knownPharmacists:
                                                            _vm.knownPharmacists,
                                                          assignedPharmacist:
                                                            _vm.assignedPharmacist,
                                                          pharmacy:
                                                            _vm.pharmacy,
                                                          appointment:
                                                            _vm.group[0] ||
                                                            _vm.appointment,
                                                          group: _vm.group,
                                                          numOfRequests:
                                                            _vm.numOfRequests,
                                                          "selection-enabled":
                                                            _vm.selectionEnabled,
                                                          "hydration-retry-token":
                                                            _vm.hydrationRetryToken,
                                                        },
                                                        on: {
                                                          "selected-user":
                                                            function ($event) {
                                                              return _vm.$emit(
                                                                "selected-user",
                                                                $event
                                                              )
                                                            },
                                                          "is-loading":
                                                            function ($event) {
                                                              _vm.mutationLoading =
                                                                $event
                                                            },
                                                          "hydration-started":
                                                            function ($event) {
                                                              _vm.outstandingHydrations += 1
                                                            },
                                                          "hydration-finished":
                                                            function ($event) {
                                                              _vm.outstandingHydrations =
                                                                Math.max(
                                                                  0,
                                                                  _vm.outstandingHydrations -
                                                                    1
                                                                )
                                                            },
                                                          "requests-updated":
                                                            _vm.getGroup,
                                                        },
                                                      }
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1783834840
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }